// This function is used to sort the rows returned by a query
// It assumes that one of the columns in rows contains the label
// It then uses a presorted labels array to enforce that order
/**
 * @param  {array} labels - array which enforces the order of rows
 * @param  {any} a
 * @param  {any} b
 * @param  {string} label_column
 */
const sortFunc = (labels, a, b, label_column) =>
  labels.indexOf(a[label_column]) > labels.indexOf(b[label_column])
    ? 1
    : labels.indexOf(b[label_column]) > labels.indexOf(a[label_column])
    ? -1
    : 0;

export default sortFunc;


// WEBPACK FOOTER //
// ./utils/sortFunc.js